import { Type } from 'class-transformer';
import { BlockIssuesResultDto } from './block-issues-result-dto';
import { ConveyanceCommunityAssessmentRuleResultDto } from './conveyance-community-assessment-rule-result-dto';
import { ConveyanceCurrentAssessmentRulesRawDto } from './conveyance-current-assessment-rules-raw-dto';

export class ConveyanceAssessmentEditorResultDto {
    @Type(() => BlockIssuesResultDto)
    blockIssues: BlockIssuesResultDto[];

    sellerType: string;
    buyerType: string;

    @Type(() => ConveyanceCommunityAssessmentRuleResultDto)
    communityAssessmentRules: ConveyanceCommunityAssessmentRuleResultDto[];

    @Type(() => ConveyanceCurrentAssessmentRulesRawDto)
    currentAssessmentRules: ConveyanceCurrentAssessmentRulesRawDto[];
}
